import Accordion from '../accordion/accordion';

const ContentListing = (function ContentListing() {
//#region Variables
	let component = document.querySelector('.content-listing');
	let openSidebarBtn = document.querySelectorAll('.sidebar-open');
	let closeSidebarBtn = document.querySelector('.sidebar-close');
	let listingSidebar = document.querySelector('.listing-sidebar');
	let overlay = document.querySelector('.overlay');
	let body = document.querySelector('body');
	let filterOptionsElements = document.querySelectorAll('.filter-list .custom-checkbox-input');
	let filterOptionsDesktopElements = document.querySelectorAll('.filter__container .custom-dropdown input[type=checkbox]');
    let filterOptionsMobileElements = document.querySelectorAll('.accordion-content .js-met-mobile-filter-list input[type=checkbox]');
	let filtersCount = 0;
	let activeFilters = [];
	let selectedOptions = [];
	let focusableElements = listingSidebar && listingSidebar.querySelectorAll('a, button, input, textarea, select');
	let showListingResults = document.querySelector('.show-listing-results');
	let urlParams = new URL(location.href).searchParams;
	let clearAllFiltersBtn = document.querySelector('.clear-all-listing-filters');
	let listingSortSelect = document.querySelector('.listing-sort');
	let totalResultsElement = document.querySelectorAll('.total-results');
	const accordions = document.querySelectorAll('.accordion');
//#endregion

//#region Event setup
	const metPaginationBtnEvents = () => {
		let paginationBtns = document.querySelectorAll('.js-met-pagination');
		paginationBtns.forEach(btn => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				if (e.currentTarget.disabled == true) {
					return;
				}
				e.currentTarget.disabled = true;
				let pageNumber = e.currentTarget.getAttribute('page-id');
				switch (e.currentTarget.getAttribute("page-id")) {
					case "next":
						let currentPage = Number(urlParams.get("pageNumber"));
						pageNumber = currentPage === 0 ? 2 : currentPage + 1;
						urlParams.set('pageNumber', pageNumber);
						break;
					case "previous":
						pageNumber = Number(urlParams.get("pageNumber")) - 1;
						urlParams.set('pageNumber', pageNumber);
						break;
					default:
						break;
				}
				handleSearch(null, null, pageNumber);
			});
		});
	};

	const paginationBtnEvents = () => {
		let paginationBtns = document.querySelectorAll('.page-number');
		paginationBtns.forEach(btn => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				if (e.currentTarget.disabled == true) {
					return;
				}
				e.currentTarget.disabled = true;
				switch (e.currentTarget.getAttribute("page-id")) {
					case "next":
						goToNextPage();
						break;
					case "previous":
						goToPreviousPage();
						break;
					default:
						goToPage(e.target.getAttribute("page-id"));
				}

			});
		});
	};

	function attachEvents() {
		paginationBtnEvents();
		metPaginationBtnEvents();
		if (openSidebarBtn) {
			openSidebarBtn.forEach((btn) => {
				btn.addEventListener('click', function(e) {
					e.preventDefault();
					if (window.innerWidth >= 768 && document.querySelector('[data-metindex]')) {
						toggleFilters();
					} else {
						openSidebar();
					}
				});
			});
		}

		closeSidebarBtn && closeSidebarBtn.addEventListener('click', function(e) {
			e.preventDefault();
			closeSidebar();
		});
		overlay && overlay.addEventListener('click', function(e) {
			closeSidebar();
		});
		filterOptionsElements.forEach(filter => {
			filter.addEventListener('click', function() {
				toggleActiveFilters(this);
			});
		});
		document.addEventListener('keydown', function(e) {
			trapSidebarFocus(e);
		});
		showListingResults && showListingResults.addEventListener('click', function() {
			if(!showListingResults.classList.contains('js-met-show-button')) 
			{
				setCategoryParams();
				goToPage(1); 
			}
            closeSidebar();
		});
		clearAllFiltersBtn && clearAllFiltersBtn.addEventListener('click', function(e) {
			e.preventDefault();
			clearFilters();
		});
		listingSortSelect && listingSortSelect.addEventListener('change', function(e) {
			setSortParams(this.options[this.selectedIndex].value);
		});
		if (accordions.length > 0) {
			accordions.forEach((accordionElement) => {
				new Accordion(`#${ accordionElement.id }`);
			});
		}
	}
//#endregion

//#region Sidebar
    function openSidebar() {
		restoreChecked();
        overlay.classList.add('show', 'no-blur');
        body.classList.add('overflow-hidden');
        listingSidebar.classList.add('show');
        listingSidebar.focus();
    }

    function closeSidebar() {
        overlay.classList.remove('show', 'no-blur');
        body.classList.remove('overflow-hidden');
        listingSidebar.classList.remove('show');
        restoreChecked();
    }

    function trapSidebarFocus(e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            if (document.activeElement === focusableElements[0]) {
                focusableElements[focusableElements.length - 1].focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === focusableElements[focusableElements.length - 1]) {
                focusableElements[0].focus();
                e.preventDefault();
            }
        }
    }

//#endregion

//#region Filters
	const toggleFilters = (showFilter = false) => {
		if (document.querySelector('[data-filters]')) {
			const filterGroup = document.querySelector('[data-filters]');
			if (showFilter) {
				filterGroup.classList.add('show-opacity');
			} else {
				filterGroup.classList.toggle('show-opacity');
			}
		}
	};
	
	function clearFilters() {
		activeFilters = [];
		if (document.querySelectorAll('.filter-list .custom-checkbox-input')) {
			filterOptionsElements.forEach(filter => {
				filter.checked = false;
			});
			updateFiltersCount(0);
		}
	};

	function checkActiveFilters() {
		if (urlParams.get('category')) {
			let foundFilters = urlParams.get('category').toLowerCase().split('_');
			activeFilters = foundFilters;

			filterOptionsElements.forEach(filter => {
				if (activeFilters.includes(filter.getAttribute('name').toLowerCase())) {
					filter.checked = true;
					filtersCount++;
					updateFiltersCount(filtersCount);
				}
			});
		}
	};

	function checkActiveDesktopFilters() {
		if (urlParams.get('category')) {
			filterOptionsDesktopElements.forEach(filter => {
				if (activeFilters.includes(filter.getAttribute('name').toLowerCase())) {
					filter.checked = true;
					updateFiltersCount(filtersCount);
				}
			});
		}
	};
	
	function checkActiveMobileFilters() {
		if (urlParams.get('category')) {
			filterOptionsMobileElements.forEach(filter => {
				if (activeFilters.includes(filter.getAttribute('name').toLowerCase())) {
					filter.checked = true;
					updateFiltersCount(filtersCount);
				}
			});
		}
	};
    
	function toggleActiveFilters(filter) {
		if (filter.checked) {
			activeFilters.push(filter.getAttribute('name').toLowerCase());
			filtersCount++;
			updateFiltersCount(filtersCount);
		} else {
			activeFilters.splice(activeFilters.indexOf(filter.getAttribute('name').toLowerCase()), 1);
			filtersCount--;
			updateFiltersCount(filtersCount);
		}
	};

	function toggleActiveFiltersV2(filterName, checked) {
		if (checked) {
			activeFilters.push(filterName.toLowerCase());
			filtersCount++;
			updateFiltersCount(filtersCount);
		} else {
			activeFilters.splice(activeFilters.indexOf(filterName.toLowerCase()), 1);
			filtersCount--;
			updateFiltersCount(filtersCount);
		}
		//console.log(activeFilters);
	};
	
    function updateFiltersCount(count) {
		filtersCount = count;

		document.querySelectorAll('.listing-filter-count').forEach(el => {
			el.innerHTML = '(' + count + ')';
		});


		document.querySelectorAll('.listing-control-btn').forEach(btn => {
			let filterText = btn.querySelector('.listing-filter-text')?.textContent.trim() ?? 'Filter';
			btn.setAttribute('aria-label', filterText + ' (' + count + ') | Show/Hide Filter Menu');
		});
	};

    function restoreChecked() {
		let elements = filterOptionsElements.length > 0 ? filterOptionsElements : filterOptionsMobileElements;
		elements.forEach(filter => {
			filter.checked = false;
			if (activeFilters.includes(filter.getAttribute('name').toLowerCase())) {
				filter.checked = true;
			}
		});

		updateFiltersCount(activeFilters.length);
	};

    function desktopFilters() {
		if (document.querySelectorAll('.custom-dropdown')) {
			document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
				const selected = dropdown.querySelector('.dropdown-selected');
				const options = dropdown.querySelector('.dropdown-options, .filter-list');

				dropdown.addEventListener('click', () => {
					const isAlreadyOpen = options.classList.contains('show');

					// Close all other dropdowns
					document.querySelectorAll('.custom-dropdown .dropdown-options').forEach(option => {
						option.classList.remove('show');
						option.closest('.custom-dropdown').classList.remove('show');
					});

					// Toggle the clicked dropdown only if it wasn't already open
					if (!isAlreadyOpen) {
						dropdown.classList.add('show');
						options.classList.add('show');
					}
				});

				//const selectedOptions = [];
				options.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
					checkbox.addEventListener('change', (event) => {
						if (!event.target.checked) {
							activeFiltersToggle(event.target.value, false);
						}

						options.querySelectorAll('input[type="checkbox"]:checked').forEach(checked => {
							activeFiltersToggle(checked.value, true);
							selectedOptions.push({
								name: checked.name,
								value: checked.value,
								dataValue: checked.dataset.value
							});
						});

						toggleActiveFiltersV2(event.target.name, event.target.checked);
						// Build the dynamic query string
						const queryString = activeFilters.length
							? activeFilters.map(option => `${ option }`).join('_')
							: '';

						handleSearch(null, queryString, 1);
					});
				});
			});

			document.addEventListener('click', event => {
				if (!event.target.closest('.custom-dropdown')) {
					document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
						dropdown.classList.remove('show');
					});
					document.querySelectorAll('.dropdown-options').forEach(options => {
						options.classList.remove('show');
					});
				}
			});
		}
	};

    function mobileFilters() {
        //accordion-content
        let accordionContent = document.querySelectorAll('.accordion-content');
        if(accordionContent) {
            accordionContent.forEach(dropdown => {
				const options = dropdown.querySelector('.js-met-mobile-filter-list');

				dropdown.addEventListener('click', () => {
					const isAlreadyOpen = options.classList.contains('show');

					// Close all other dropdowns
					document.querySelectorAll('.custom-dropdown .dropdown-options').forEach(option => {
						option.classList.remove('show');
						option.closest('.custom-dropdown').classList.remove('show');
					});

					// Toggle the clicked dropdown only if it wasn't already open
					if (!isAlreadyOpen) {
						dropdown.classList.add('show');
						options.classList.add('show');
					}
				});

				options.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
					checkbox.addEventListener('change', (event) => {
						if (!event.target.checked) {
							activeFiltersToggle(event.target.value, false);
						}

						options.querySelectorAll('input[type="checkbox"]:checked').forEach(checked => {
							activeFiltersToggle(checked.value, true);
							selectedOptions.push({
								name: checked.name,
								value: checked.value,
								dataValue: checked.dataset.value
							});
						});

						toggleActiveFiltersV2(event.target.name, event.target.checked);
						// Build the dynamic query string
						const queryString = activeFilters.length
							? activeFilters.map(option => `${ option }`).join('_')
							: '';

						handleSearch(null, queryString);
					});
				});
            });
        }

        document.addEventListener('click', event => {
            if (!event.target.closest('.custom-dropdown')) {
                document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
                    dropdown.classList.remove('show');
                });
                document.querySelectorAll('.dropdown-options').forEach(options => {
                    options.classList.remove('show');
                });
            }
        });
    };

	const activeFiltersToggle = (targetFilter, isTargetToDisplay = false) => {
		if (document.querySelector('[data-activefilters]')) {
			const activeFiltersContainer = document.querySelector('[data-activefilters]');
			const targetFilterItem = activeFiltersContainer.querySelector('#' + targetFilter + '-active');
			if (isTargetToDisplay) {
				activeFiltersContainer.dataset.activefilters = 'true';
				if (targetFilterItem !== null) {
					targetFilterItem.dataset.active = 'true';
				}
			} else {
				targetFilterItem.dataset.active = 'false';
			}
			if (document.querySelectorAll('[data-filterbtn][data-active="true"]').length === 0) {
				
				const searchTerm = document.querySelector('.search-bar form [name="searchTerm"]').value;
				if (activeFiltersContainer.dataset.activefilters === 'true' && !searchTerm) {
					activeFiltersContainer.dataset.activefilters = 'false';
				}
			}
		}
	};

	const clearActiveFilters = () => {
		if (document.querySelector('[data-clearfilters]')) {
			document.querySelector('[data-clearfilters]').addEventListener('click', () => {
				const activeFiltersContainer = document.querySelector('[data-activefilters]');
				const activeFiltersList = document.querySelectorAll('[data-activefilters] [data-filterbtn]');
				const activeCheckboxes = document.querySelectorAll('.custom-checkbox input[type="checkbox"]:checked');
				activeFiltersList.forEach(filter => {
					if (filter.dataset.active === 'true') {
						filter.dataset.active = 'false';
					}
				});
				if (activeFiltersContainer.dataset.activefilters === 'true') {
					activeFiltersContainer.dataset.activefilters = 'false';
				}
				activeCheckboxes.forEach(checkbox => {
					checkbox.checked = false;
				});
				if (document.querySelector('.search-bar form .search-input')) {
					document.querySelector('.search-bar form .search-input').value = '';
				}
				deleteAllParamsFromUrl();
				activeFilters = [];
				handleSearch(null, null, null);
			});
		}
	};

	const activeFiltersListEvent = () => {
		if (document.querySelectorAll('[data-filterbtn]')) {
			const filtersList = document.querySelectorAll('[data-filterbtn]');
			filtersList.forEach(filter => {
				filter.addEventListener('click', () => {
					if (filter.dataset.active === "true") {
						activeFiltersToggle(filter.id.replace('-active', ''), false);
						document.querySelector('#' + filter.id.replace('-active', '')).checked = false;
						const event = new Event('change');
						document.querySelector('#' + filter.id.replace('-active', '')).dispatchEvent(event);
					}
				});
			});
		}
	};

	const reenableActiveFilters = () => {
		if (document.querySelector('[data-activefilters]')) {
			const activeFiltersContainer = document.querySelector('[data-activefilters]');
			const activeCheckboxes = document.querySelectorAll('.custom-checkbox input[type="checkbox"]:checked');
			if (activeCheckboxes.length > 0) {
				if (document.querySelector('.content-slider__container')) {
					document.querySelectorAll('.content-slider__container').forEach(container => {
						container.classList.add('d-none');
					});
				}
				
				toggleFilters(true);
				
				activeFiltersContainer.dataset.activefilters = 'true';
				activeCheckboxes.forEach(targetFilterItem => {
					document.querySelector('#' + targetFilterItem.value + '-active').dataset.active = 'true';
				});
			}
		}
	};
	
    const disableFilters = (data) => {
		const filterElements = filterOptionsElements && filterOptionsElements.length > 0
			? filterOptionsElements
			: filterOptionsMobileElements;

		const filterOptions = Array.from(filterElements)
			.map(el => ({
				id: el.name,
				name: el.name
			})
		);
		
		const matches = data.disabledFilters.filter(item1 =>
			filterOptions.find(
				item2 => item1.fullCategoryPath === item2.name
			)
		);

		filterOptionsElements.forEach(domItem => {
			const match = matches.find(match => match.fullCategoryPath === domItem.name);
			if (match) {
				domItem.setAttribute('disabled', 'true');
				domItem.style.opacity = 0.5;
			}
		});
		filterOptionsDesktopElements.forEach(desktopFilter => {
			const match = matches.find(match => match.fullCategoryPath == desktopFilter.name);
			if (match) {
				desktopFilter.setAttribute('disabled', 'true');
				desktopFilter.style.opacity = 0.5;
			} else {
				desktopFilter.removeAttribute('disabled');
				desktopFilter.style.opacity = 1;
			}
		});

        filterOptionsMobileElements.forEach(mobileFilter => { 
            const match = matches.find(match => match.fullCategoryPath == mobileFilter.name);
            if (match) {
                mobileFilter.setAttribute('disabled', 'true');
                mobileFilter.style.opacity = 0.5;
            } else {
                mobileFilter.removeAttribute('disabled');
                mobileFilter.style.opacity = 1;
            }
        });

		$(window).scrollTop(0);

		//window.scrollTo({
		//	top: 0, 
		//	behavior: 'smooth'
		//});
	};

//#endregion

//#region Pagination
    function updatePaginationTotalResults(data) {
		// Math.ceil(data.contentCardCount/data.maxPerPage)
		// data.pageNumber
		if (totalResultsElement) {
			const totalResultsLabel = document.querySelector('[data-filterresultscount]');
			const totalResults = data.contentCardCount;
			const firstResult = data.firstResultNumber;
			const lastResult = Math.min(data.lastResultNumber, totalResults);

			totalResultsLabel.innerText = totalResults + ' Results';
			/*const totalResults = data.contentCardCount;
			const maxPerPage = data.maxPerPage;
			const pageNumber = data.pageNumber;

			const firstResult = (pageNumber - 1) * maxPerPage + 1;
			const lastResult = Math.min(pageNumber * maxPerPage, totalResults);*/

			// Update the inner HTML of the total results element
			totalResultsElement.forEach(element => {
				element.innerHTML = `Showing ${ firstResult } - ${ lastResult } of ${ totalResults } Results`;
			});
		}
	};

    function updatePagination(data) {
		const paginationElements = document.querySelectorAll('.pagination.content-listing-pagination');
		const paginationContainer = document.querySelector('[data-paginationcontainer]');
		const errorMsg = document.querySelector('[data-errormsg]');
		paginationElements.forEach(paginationElement => {
			const totalResults = data.contentCardCount;
			const maxPerPage = data.maxPerPage;
			const pageNumber = data.pageNumber;
			const totalPages = Math.ceil(totalResults / maxPerPage);

			if (totalResults > 0) {
				errorMsg.classList.add('d-none');
				paginationContainer.classList.remove('d-none');
				// Clear existing pagination items
				paginationElement.innerHTML = '';

				// Helper function to create pagination item
				const createPaginationItem = (page, isActive, isDisabled, label, isEllipsis) => {
					const li = document.createElement('li');
					li.classList.add('pagination-item');
					if (isActive) li.classList.add('active');
					if (isDisabled) li.classList.add('disabled');

					const a = document.createElement('a');
					if (!isEllipsis) {
						a.classList.add('page-number', 'js-met-pagination');
						a.setAttribute('href', '/');
						a.setAttribute('page-id', page);
						a.setAttribute('aria-current', isActive ? 'true' : 'false');
						a.setAttribute('aria-label', label || `Page ${ page }`);
						if (page === 'previous' || page === 'next') {
							if (page === 'next') {
								a.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" /></svg>';
							} else {
								a.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" /></svg>';
							}
						} else {
							a.textContent = isEllipsis ? '...' : page;
						}
						if (isDisabled) {
							a.setAttribute('aria-hidden', 'true');
							a.setAttribute('tabindex', '-1');
						}
					} else {
						a.setAttribute('href', '/');
						a.setAttribute('aria-hidden', 'true');
						a.setAttribute('tabindex', '-1');
						a.textContent = '...';
					}

					li.appendChild(a);
					return li;
				};

				// Create "previous" button
				const prevDisabled = pageNumber === 1;
				const prevItem = createPaginationItem('previous', false, prevDisabled, 'Goto Previous Page');
				paginationElement.appendChild(prevItem);

				// Create page number buttons
				const maxVisiblePages = 5;
				let startPage = Math.max(1, pageNumber - Math.floor(maxVisiblePages / 2));
				let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

				if (endPage - startPage + 1 < maxVisiblePages) {
					startPage = Math.max(1, endPage - maxVisiblePages + 1);
				}

				if (startPage > 1) {
					paginationElement.appendChild(createPaginationItem(1, false, false));
					if (startPage > 2) {
						paginationElement.appendChild(createPaginationItem('ellipsis', false, true, '', true));
					}
				}

				for (let i = startPage; i <= endPage; i++) {
					const isActive = i === pageNumber;
					const pageItem = createPaginationItem(i, isActive, false);
					paginationElement.appendChild(pageItem);
				}

				if (endPage < totalPages) {
					if (endPage < totalPages - 1) {
						paginationElement.appendChild(createPaginationItem('ellipsis', false, true, '', true));
					}
					paginationElement.appendChild(createPaginationItem(totalPages, false, false));
				}

				// Create "next" button
				const nextDisabled = pageNumber === totalPages;
				const nextItem = createPaginationItem('next', false, nextDisabled, 'Goto Next Page');
				paginationElement.appendChild(nextItem);
			} else {
				errorMsg.classList.remove('d-none');
				paginationContainer.classList.add('d-none');
			}
		});
		metPaginationBtnEvents();
		paginationBtnEvents();
    };
    
	function goToPage(page) {
		urlParams.set('pageNumber', page);
		window.location.hash = '#listing-title-anchor';
		window.location.search = urlParams;
	};

	function goToNextPage() {
		let currentPage = Number(urlParams.get("pageNumber"));
		let nextPage = currentPage === 0 ? 2 : currentPage + 1;
		urlParams.set('pageNumber', nextPage);
		window.location.hash = '#listing-title-anchor';
		window.location.search = urlParams;
	};

	function goToPreviousPage() {
		var page = Number(urlParams.get("pageNumber")) - 1;
		urlParams.set('pageNumber', page);
		window.location.hash = '#listing-title-anchor';
		window.location.search = urlParams;
	};

//#endregion

//#region URL params
	function setCategoryParams(setHistory = false) {
		const searchTerm = new URLSearchParams(window.location.search).get('searchTerm');
		if (activeFilters.length > 0) {
			urlParams.set('category', activeFilters.join('_'));
		} else {
			urlParams.delete('category');
		}

		if (searchTerm) {
			urlParams.set('searchTerm', searchTerm);
		} else {
			urlParams.delete('searchTerm');
		}
		const pageNumber = new URLSearchParams(window.location.search).get('pageNumber');
		if (pageNumber) {
			urlParams.set('pageNumber', pageNumber);
		}
		else {
			urlParams.delete('pageNumber');
		}
		if (setHistory) {
			const newUrl = `${window.location.pathname}?${urlParams}`;
			history.pushState(null, '', newUrl);
		} else {
			window.location.hash = '#listing-title-anchor';
			window.location.search = urlParams;
		}
	};

	function setSortParams(value) {
		urlParams.set('sort', value);
		window.location.hash = '#listing-title-anchor';
		window.location.search = urlParams;
	};

    const deleteAllParamsFromUrl = () => {
		const url = new URL(window.location.href);
		url.search = ''; // Set the search property to an empty string
		window.history.replaceState({}, '', url); // Update the URL without reloading
	};
    
    function updateSortDropdown() {
		if (urlParams.get('sort')) {
			listingSortSelect.value = urlParams.get('sort');
		}
	};

	function handleSearchAll() {
		if (document.querySelector('[data-metindex]')) {
			if (urlParams.get('option') === 'all') {
				deleteAllParamsFromUrl();
				urlParams = new URL(location.href).searchParams;
				handleSearch(null, null, 1);
			}
		}
	}

//#endregion


	const repaintCards = (data) => {
		if (document.querySelector('#cards-container')) {
			if (document.querySelector('.content-slider__container')) {
				document.querySelectorAll('.content-slider__container').forEach(container => {
					if (data['contentCards']['cards'].length) {
						container.classList.add('d-none');
					} else {
						container.classList.remove('d-none');
					}
				});
			}
			const cardsContainer = document.querySelector('#cards-container');
			cardsContainer.innerHTML = ''; // Clear existing cards
			data['contentCards']['cards'].forEach(item => {
				const card = document.createElement('a');
				// obj keys: altText, image, link, linkLabel, title, description
				card.classList.add('content-card');
				card.href = item.link.replace(/~/g, '');
				card.innerHTML = `            
				<div class="content-card-image">
					<img src="${ item.image }" alt="${ item.altText }" class="">
				</div>
				<div class="content-card-content">
						<p class="h4 content-card-title">${ item.title }</p>
						<p class="content-card-description">${ item.description }</p>
				</div>
        `;
				cardsContainer.appendChild(card);
			});
		}
	};
	
	const initSearchTerms = () => {
		if (document.querySelector('[data-metindex]')) {
			if (document.querySelector('.search-bar form')) {
				document.querySelector('.search-bar form').addEventListener("submit", function(event) {
					event.preventDefault();
					const searchTerm = document.querySelector('.search-bar form [name="searchTerm"]').value;
					handleSearch(searchTerm, null, 1);
					toggleFilters(true);
					activeFiltersToggle(null, true);
				});
			}
		}
	};

	/**
	 * Handles search and filter actions to build the API URL and fetch data.
	 *
	 * @param {string|null} [searchTermValue] - The search term value provided by the user (if not filter action).
	 * @param {string|null} [categoryValue] - The category query string value provided by the user (if filter action).
	 */
	const handleSearch = ( searchTermValue, categoryValue, pageNumberValue) => {
		let apiUrl = `${ window.location.origin }/api/recipe/query`;

		setCategoryParams(true);
		const searchTerm = searchTermValue
			? searchTermValue
			: new URLSearchParams(window.location.search).get('searchTerm');

		const categoryString = categoryValue
			? categoryValue
			: new URLSearchParams(window.location.search).get('category');

		const pageNumber = pageNumberValue 
			? pageNumberValue 
			: new URLSearchParams(window.location.search).get('pageNumber');

		if (searchTerm || categoryString || pageNumber) {
			const params = new URLSearchParams();
			if (searchTerm) params.append('searchTerm', searchTerm);
			if (categoryString) params.append('category', categoryString);
			if (pageNumber) params.append('pageNumber', pageNumber);

			apiUrl += `?${ params.toString() }`;
		}

		const url = new URL(window.location);
		if (searchTerm) {
			url.searchParams.set('searchTerm', searchTerm);
		} else {
			url.searchParams.delete('searchTerm');
		}

		if (categoryString) {
			url.searchParams.set('category', categoryString);
			toggleFilters(true);
		} else {
			url.searchParams.delete('category');
		}

		if (pageNumber) {
			url.searchParams.set('pageNumber', pageNumber);
		} else {
			url.searchParams.delete('pageNumber');
		}

		window.history.pushState({}, '', url);
		fetch(apiUrl)
			.then(response => response.json())
			.then(data => {
				updatePaginationTotalResults(data);
				updatePagination(data);
				repaintCards(data);
				disableFilters(data);
			})
			.catch(error => console.error('Error:', error));
	};

	function init() {
		if (!component) {
			return;
		}
		handleSearchAll();
		attachEvents();
		desktopFilters();
        mobileFilters();
		initSearchTerms();
		activeFiltersListEvent();
		clearActiveFilters();
		checkActiveFilters();
		checkActiveDesktopFilters();
		checkActiveMobileFilters();
		updateSortDropdown();
		reenableActiveFilters();
	};

	// add a setTimeout 1000ms for the functions below in case the code is running on vite server
	init();
})();